import { render } from "./Game.vue?vue&type=template&id=1396dbf4&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=1396dbf4&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1396dbf4"]])

export default __exports__